import { signal } from '@preact/signals'

import { LOCAL, DEVELOPMENT, STAGE, PRODUCTION } from './environments'

interface IBASE_URL_MAP {
  [key: string]: string
}

export const BASE_URL_MAP: IBASE_URL_MAP = {
  'dashboard.rhuna.io': PRODUCTION,
  'staging-dashboard.extasy.com': STAGE,
  'dev-dashboard.extasy.com': DEVELOPMENT,
}

export const API_BASE_URL_MAP: IBASE_URL_MAP = {
  [PRODUCTION]: 'https://api.b2b.extasy.com',
  [STAGE]: 'https://api-staging.b2b.extasy.com',
  [DEVELOPMENT]: 'https://api-dev.b2b.extasy.com',
  [LOCAL]: 'https://api-dev.b2b.extasy.com',
}

export const xFestivalName = signal(
  localStorage?.getItem('festivalName') !== 'undefined'
    ? localStorage?.getItem('festivalName')
    : 'untold',
)
